module.exports = __webpack_public_path__ + "static/media/logo.248ec254.svg";